import { notification } from 'antd';
import { codeTypeEnum, idCardType } from '@/configs/qualification';

import {
  // 查询门店资质
  searchQualificationUrlById,
  // 提交修改门店资质
  submitQualification,
  // 查询门店基本信息
  searchPoiById,
} from '../services/api';
import router from 'umi/router';

const QCErrorHandler = async ({ code, msg = '', data = {} }) => {
  notification.error({
    message: '提交失败',
    description: msg,
    duration: 0,
  });
};

export default {
  namespace: 'qualification',
  state: {
    searchFilter: {
      type: 'dpId', // 按何种方式搜索 dpId mtId 默认按照点评门店
      key: '', // 用户在搜索框的输入
    },
    // 门店基本信息
    searchPoiResult: {},
    // 资质列表
    qualificationList: [],
  },
  effects: {
    // 根据 Id 搜索 资质相关信息
    *searchQualificationUrlById({ payload }, { call, put }) {
      const list = yield call(searchQualificationUrlById, payload);
      const qualificationList = list.reduce((prev, curr) => {
        let temp = curr;
        // 身份证被合成了一条数据，需添加二级分类并拆成2条数据
        if (curr.codeType === codeTypeEnum.idCard) {
          temp = (curr?.imageLinkList || []).map((item, index) => ({
            ...curr,
            imageLinkList: [item],
            subType: index === 0 ? idCardType.front : idCardType.back,
          }));
        }
        return prev.concat(temp);
      }, []);
      if (qualificationList) {
        yield put({
          type: 'setField',
          payload: {
            qualificationList,
          },
        });
      }
    },
    // 根据 Id 搜索 门店基本信息
    *searchQualificationBasicById({ payload }, { call, put }) {
      const searchPoiResult = yield call(searchPoiById, payload);
      if (searchPoiResult) {
        // 将 用户输入的搜索关键词，放到 searchFilter 的 key 字段
        yield put({
          type: 'setSearchFilter',
          payload: {
            key: payload.shopId,
          },
        });
        yield put({
          type: 'setField',
          payload: {
            searchPoiResult,
          },
        });
      }
    },

    *submitQualification({ payload }, { call, put, select }) {
      const response = yield call(submitQualification, payload, QCErrorHandler);
      if (response && typeof response === 'string') {
        yield put({
          type: 'success/setSuccessField',
          payload: {
            flowId: response,
          },
        });
        router.push('/errors/result/success');
      }
    },
  },
  reducers: {
    setSearchFilter(state, action) {
      const { payload } = action;
      const { searchFilter } = state;
      return {
        ...state,
        searchFilter: {
          ...searchFilter,
          ...payload,
        },
      };
    },
    setField(state, action) {
      const { payload } = action;
      return {
        ...state,
        ...payload,
      };
    },
  },
};
